/**
 * Which way the view pitches when the hand moves, for every mode at once.
 *
 * Some players fly: push forward to look down, the way a stick has always done it. The switch is
 * a sign on pitch and nothing else, applied where the control maps turn pointer counts into look
 * deltas. Yaw never inverts, because nobody's model of left is right, and movement never inverts,
 * because the preference is about the view and a backwards walk would be a different setting
 * nobody has asked for.
 *
 * Read per tick rather than captured, like every preference under `core/`: the settings screen
 * changes it with a game running behind it and the very next frame pitches the other way.
 */

/** Pitch follows the hand, the way a mouse-first shooter defaults. */
export const DEFAULT_LOOK_Y_INVERTED = false;

let inverted = DEFAULT_LOOK_Y_INVERTED;

export function setLookYInverted(value: boolean): void {
  inverted = value;
}

/** What a control map multiplies its pitch delta by, and only its pitch delta. */
export function lookPitchSign(): number {
  return inverted ? -1 : 1;
}
